import {
  ExpandedDomainsDataAction,
  LOAD_EXPANDED_DATA,
  EXPANDED_DATA_FAIL,
  EXPANDED_DATA_SUCCESS, ExpandedDomainsDataSuccess
} from "../actions";

export interface IDomainExpandedDataEntityState {
  domainPointed: number;
  hasCertificate: number;
  hasIpv6: boolean;
  server: string;
  tenWebCf: boolean;
  tenWebDomain: boolean;
  tenWebIp: boolean;
  tenWebNs: boolean;
  verificationNeeded: boolean;
  pending: boolean;
}

export interface IDomainExpandedDataState {
  entities: {[websiteId: number]: IDomainExpandedDataEntityState};
  loading: boolean;
  loaded: boolean;
}

export const initialState: IDomainExpandedDataState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IDomainExpandedDataState = initialState, action: ExpandedDomainsDataAction): IDomainExpandedDataState {
  switch (action.type) {
    case  LOAD_EXPANDED_DATA:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case EXPANDED_DATA_SUCCESS:
      const payload = (action as ExpandedDomainsDataSuccess).payload;
      const updatedEntities = { ...state.entities };
      Object.keys(payload.entities).forEach(websiteId => {
        updatedEntities[websiteId] = {
          ...state.entities[websiteId],
          ...payload.entities[websiteId],
          loading: false,
          loaded: true
        };
      });

      return {
        ...state,
        entities: updatedEntities,
        loading: false,
        loaded: true
      };


    case  EXPANDED_DATA_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false
      };
  }

  return state;
}
